export default __webpack_public_path__ + "static/fs-835c91933bd4054bcd6674dfbcd36607.jpg";